module.exports = __webpack_public_path__ + "img/octopus-pass.b0a5459b.svg";